import { useMutation } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useUpdateUserLocation = () => {
  return useMutation({
    mutationFn: async ({ lat, lng }: { lat: number; lng: number }) => {
      await api.patch('/users/location', { lat, lng });
    },
  });
};
